import { Component, OnInit } from '@angular/core';
import { HelpService } from "./help.service";
import { CommonUtilitiesService } from '../common-utilities.service';
import { DomSanitizer } from '@angular/platform-browser';
import { constants } from '../constants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
//jquery var
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  listHelp = [];
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  helpForm: FormGroup;

  constructor(private helpService : HelpService, public LANG: CommonUtilitiesService, private formbuilder: FormBuilder, private _sanitizer: DomSanitizer) { }
  

  ngOnInit() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.helpForm = this.formbuilder.group({      
      inputSearch: ['', []]  
    });


    this.searchTopics();
  }

  /**
   * Description: Método que llama el servicio web que obtiene las ayudas
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  searchTopics(){

    this.helpService.getHelpTopics(this.helpForm.get('inputSearch').value.trim()).subscribe((dataInfo => {
      if(dataInfo['responseCode'] !=  constants.SUCCESS_WS_RESPONSE_CODE){
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      }

      //Original
      //this.listHelp = dataInfo['obj'];

      /////////////////////////////////////////////////////
      //Codigo temporal filtrando solo recargas
      this.listHelp = [];
      for(let k in dataInfo['obj']){
        if(dataInfo['obj'][k].category == "RECARGAS"){
          this.listHelp.push(dataInfo['obj'][k]);
        }        
      }
      /////////////////////////////////////////////////////

      }),
      (err) => {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
      
  }

}
